<template>
  <div class="app-container">
    <Toast />
    <ConfirmDialog />
    <!-- Solo RouterView — el Navbar lo maneja DefaultLayout -->
    <RouterView />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
</script>

<style scoped>
.app-container {
  min-height: 100vh;
}
</style>